export default __webpack_public_path__ + "static/media/menu_link_lottery_selected.dfcfb92c.svg";